module.exports = __webpack_public_path__ + "img/04.beaf53a1.jpg";